/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Terms_LabelInputs */

const en_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const de_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzungsbedingungen`)
};

const pt_br2_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Serviço`)
};

const tr_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet Şartları'nı`)
};

const zh_cn2_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

const zh_hk2_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服務條款`)
};

const ko_kr2_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`서비스 이용약관`)
};

const ru_ru2_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условиями использования Glider`)
};

const es_419_login_page_terms_label = /** @type {(inputs: Login_Page_Terms_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos del servicio de Glider`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Login_Page_Terms_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_terms_label = /** @type {((inputs?: Login_Page_Terms_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Terms_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_terms_label(inputs)
	if (locale === "de") return de_login_page_terms_label(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_terms_label(inputs)
	if (locale === "tr") return tr_login_page_terms_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_terms_label(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_terms_label(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_terms_label(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_terms_label(inputs)
	return es_419_login_page_terms_label(inputs)
});